import { render, staticRenderFns } from "./Ripslaboratorio.vue?vue&type=template&id=15fad9d2"
import script from "./Ripslaboratorio.vue?vue&type=script&lang=js"
export * from "./Ripslaboratorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports